import { useQuery } from '@apollo/client';
import gql from 'graphql-tag';

import { GetWebSession } from '../../athena/types/GetWebSession';

export const GET_WEB_SESSION = gql`
  query GetWebSession {
    web {
      userSession {
        human {
          token
          email
          opendoor_internal_access
          organizations {
            uuid
            name
          }
          vendorBranches {
            id
            name
            vendor {
              id
              name
            }
          }
        }
      }
    }
  }
`;

const useWebSession = () => useQuery<GetWebSession>(GET_WEB_SESSION);

export default useWebSession;
